import { invertObj } from 'ramda'
import { toKeyAsIdAndValueAsLabel } from './generalHelpers.js'

export const roles = {
  ADMIN: 'Admin',
  PRINT_PARTNER: 'Print Partner',
  TME_USER: 'TME User',
  TME_APPROVER: 'TME Approver',
  NMSC: 'NMSC User',
  NMSC_UPLOADER: 'NMSC Uploader'
}

export const invertedRoles = invertObj(roles)

export const rolesMap = toKeyAsIdAndValueAsLabel(roles)

export default roles
